<script setup>
import { ref, watch } from 'vue';

import NextButton from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

import { formatProviderName } from '../../helpers/kraftchatAIFormatters';
import {
  providerFormContent,
  getDefaultProviderModel,
} from '../../helpers/kraftchatAIProviderConfig';

const props = defineProps({
  credential: {
    type: Object,
    required: true,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['updateProvider', 'cancelEdit']);

const form = ref({
  default_model: '',
  api_key: '',
});

const syncForm = () => {
  form.value = {
    default_model:
      props.credential.default_model ||
      getDefaultProviderModel(props.credential.provider),
    api_key: '',
  };
};

const handleSubmit = () => {
  emit('updateProvider', {
    provider: props.credential.provider,
    default_model: form.value.default_model,
    api_key: form.value.api_key,
  });
};

watch(
  () => props.credential,
  () => {
    syncForm();
  },
  { immediate: true }
);
</script>

<template>
  <form class="space-y-4" @submit.prevent="handleSubmit">
    <div class="space-y-1">
      <h4 class="text-sm font-semibold text-n-slate-12">
        {{ formatProviderName(credential.provider) }}
      </h4>

      <p class="text-sm font-medium text-n-slate-12">
        {{ providerFormContent.currentKeyLabel }}
        {{ credential.masked_api_key }}
      </p>
    </div>

    <Input
      v-model="form.default_model"
      :label="providerFormContent.modelLabel"
      :placeholder="providerFormContent.modelPlaceholder"
      size="md"
      type="text"
    />

    <Input
      v-model="form.api_key"
      autocomplete="off"
      :label="providerFormContent.apiKeyLabel"
      :message="providerFormContent.editApiKeyHelp"
      :placeholder="providerFormContent.apiKeyPlaceholder"
      size="md"
      type="password"
    />

    <div class="flex flex-wrap items-center gap-2">
      <NextButton
        type="submit"
        size="sm"
        :is-loading="isSaving"
        :label="providerFormContent.saveLabel"
      />

      <NextButton
        type="button"
        outline
        slate
        size="sm"
        :disabled="isSaving"
        :label="providerFormContent.cancelLabel"
        @click="emit('cancelEdit')"
      />
    </div>
  </form>
</template>
